import React from 'react';
import { Dispatch } from 'redux';
import { PowerBIEmbed } from "powerbi-client-react";
import * as PowerBi from 'powerbi-client';
import { Spinner } from 'react-bootstrap';
import * as ReportStore from '../../store/Report';
import { User } from 'oidc-client';
import { Embed, Page, service } from 'powerbi-client';
import { actionCreators } from '../../store/Report';
import { ICustomEvent } from 'service';
import FileExportDownloadModal from '../Common/FileExport/FileExportDownloadModal';
import { ExportFileDto } from '../../types/Common/ExportFileDto';
import { PowerBiObjectType } from '../../types/Common/PowerBiObjectType';
import { ExportFileType } from '../../types/Common/Enums/ExportFileType';
import axios, { AxiosError } from 'axios';


type ReportViewProps = {
    dispatch: Dispatch;
    reportId: string;
    reportState: ReportStore.ReportState;
    user: User;
    actions:  typeof ReportStore.actionCreators;
}

interface ReportViewState {
    report: PowerBi.Report | undefined;
    eventHandlers: Map<string, (event?: service.ICustomEvent<any>, embeddedEntity?: Embed) => void | null>;
    activePage: any | undefined;
    showExportFileModal: boolean;
    exportFileType : ExportFileType | undefined;
    isExportInProgress: boolean;
    exportId: string | undefined;
    reportContainerHeight: number;
    reportContainerHeightPx: string;
}


class ReportView extends React.Component<ReportViewProps, ReportViewState> {
    private fileExportDownloadModalChildRef: React.RefObject<FileExportDownloadModal>;
    private reportLoaded = false;
    private lastRenderedAt = 0;
    public constructor(props: ReportViewProps) {
        super(props);
        this.state = {
            exportFileType: undefined,
            isExportInProgress: false,
            exportId: undefined,
            report: undefined,
            showExportFileModal: false,
            eventHandlers: new Map([
                ['loaded', () => {
                    this.reportLoaded = true;
                    console.log('Report loaded');
                }],
                ['rendered', () => {
                    this.lastRenderedAt = Date.now();
                    console.log('Report rendered');
                }],
                ['error', (event?: service.ICustomEvent<any>) => {
                    if (event) console.error(event.detail);
                }],
                ['visualClicked', () => console.log('visual clicked')],
            ]),
            activePage: undefined,
            reportContainerHeight: 0,
            reportContainerHeightPx: "100%",
        };
        this.powerBiEmbedFullScreen = this.powerBiEmbedFullScreen.bind(this);
        this.fileExportDownloadModalChildRef = React.createRef();
    }


    public componentDidMount() {
        window.addEventListener("resize", this.updateReportContainer.bind(this));
        this.props.actions.unloadReportEmbeddedViewDetails();
        this.ensureDataFetched();

        this.updateReportContainer();
    }

    public componentDidUpdate() {
        if (!this.props.reportState.isLoadedEmbeddedViewDetails) {
            this.ensureDataFetched();
        }
    }

    public componentWillUnmount() {
        window.removeEventListener("resize", this.updateReportContainer.bind(this));
    }

    private ensureDataFetched(){
        this.props.actions.requestReportEmbeddedViewDetails(this.props.reportId);
    }

    private updateReportContainer() {
        var reportContainerElement = document.getElementById('reportContainer');
        if (reportContainerElement == null) {
            return;
        }
            
        var reportContainerTop = reportContainerElement.getBoundingClientRect().top;

        var footerElement = document.getElementsByTagName('footer');
        if (footerElement == null || footerElement.length < 1) {
            return;
        }

        var footerRect = footerElement[0].getBoundingClientRect();

        let height = footerRect.top - 20 - reportContainerTop;

        // Give React a break, screen resize can change 1 pixel at a time
        if (this.state.reportContainerHeight !== height 
            && Math.abs(this.state.reportContainerHeight - height) > 15) {
                console.log("Setting report container height to: "+height+"px");
                this.setState({reportContainerHeight: height, reportContainerHeightPx: height+"px"});
        }
    }

    // Export Modal
    private hideExportRequestModal() {
        this.setState({ showExportFileModal: false });
    }

    public exportFileRequest(exportFileType: ExportFileType) {
        this.setState({showExportFileModal: true});
        if (this.state.isExportInProgress == false) {
            this.fetchExport(exportFileType);
        }
    }

    /*
     private OnLoaded(event?: ICustomEvent<any>, embeddedEntity?: Embed) {
         // Set first page to active. per old report viewer
         let report = embeddedEntity as PowerBi.Report;
         report.getPages().then((pages) => {
            if (pages.length > 0) {
                pages[0].setActive();
            }
         });
     }*/

    private OnPageChanged(event?: ICustomEvent<any>, embeddedEntity?: Embed) {
        this.setState({activePage: event?.detail.newPage});
    }

    private async waitForLoaded(timeoutMs = 15000): Promise<void> {
        const start = Date.now();
        while (!this.reportLoaded) {
            await new Promise(res => setTimeout(res, 50));
            if (Date.now() - start > timeoutMs) return; // fail open
        }
    }

    /**
     * Wait until the report has stopped rendering for idleMs.
     * This is the key to capturing the user's latest slicer/filter changes.
     */
    private async waitForRenderIdle(idleMs = 400, timeoutMs = 15000): Promise<void> {
        const start = Date.now();

        // If we haven't seen any render yet, give it a moment
        if (this.lastRenderedAt === 0) {
            await new Promise(res => setTimeout(res, 200));
        }

        while (true) {
            const now = Date.now();

            // If no renders have happened in the last idleMs, state is stable
            if (this.lastRenderedAt > 0 && (now - this.lastRenderedAt) >= idleMs) return;

            if (now - start > timeoutMs) return; // fail open

            await new Promise(res => setTimeout(res, 50));
        }
    }

    powerBiEmbedFullScreen(){
        if (this.state.report) {
            this.state.report.fullscreen();
        }
    }

    private createNewFilter(filterJson: any) {
        const newFilter = {} as any;
        newFilter.$schema = filterJson.schema;
        newFilter.target = {};
        newFilter.target.table = filterJson.target.table;
        newFilter.target.column = filterJson.target.column;
        newFilter.filterType = filterJson.filterType;
        newFilter.operator = filterJson.Operator;
        newFilter.values = filterJson.values;

        return newFilter;
    }

    private applyFilter(filterJson: any) {
        const newFilter = this.createNewFilter(filterJson);
        let currentEmbeddedReport = this.state.report!;

        currentEmbeddedReport.getFilters()
            .then(function (filters) {
                filters.forEach((value, index) => {
                    var currentFilter = value as unknown as PowerBi.models.BasicFilter;
                    if (filterJson.target.table.toLowerCase() === (currentFilter.target as PowerBi.models.IFilterColumnTarget).table.toLowerCase() && filterJson.target.column.toLowerCase() === (currentFilter.target as PowerBi.models.IFilterColumnTarget).column.toLowerCase()) {
                        filters[index] = newFilter;
                    }
                });

                currentEmbeddedReport.setFilters(filters)
                    .then(function (result) { console.log("setFilters() - " + result); })
                    .catch(function (errors: any) { console.log("setFilters() ERROR - "); console.log(errors); });
            })
            .catch(function (errors) {
                console.log(errors);
            });
    }

    private async getBookmarkState(page: Page)  {
        // Change current view
        if (this.state.report == undefined) {
            return;
        }

        this.state.report.setPage(page.name);
        page.setActive();

        // Capture the current view state
        const bookmark = await this.state.report!.bookmarksManager.capture();
        return bookmark.state;
        
    }

    private getReportRecordId(): string | undefined {
        const embedded = this.props.reportState.embeddedReportDetailsData.find(
            x => x.aliasName === this.props.reportId || x.recordId === this.props.reportId
        );
        return embedded?.recordId;
    }

    private async fetchExport(exportFileType: ExportFileType) {
        const report = this.state.report;
        if (!report) return;

        const recordId = this.getReportRecordId();
        if (!recordId) {
            this.fileExportDownloadModalChildRef.current?.setError("Report not found.");
            return;
        }

        this.setState({exportFileType: exportFileType});

        
        // 1) Ensure report is loaded before calling APIs (recommended) 
        await this.waitForLoaded(15000)

        
        // 2) Wait until user interactions (filters/slicers/pane) have finished rendering 
        await this.waitForRenderIdle(400, 15000);

        // Capture the current view state
        // 3) Capture the current report state (bookmark)
        const defaultBookmark = await report.bookmarksManager.capture({
            allPages: true,
            personalizeVisuals: true
        });


        // 4) Include pages for export, but do not capture per-page bookmarks (avoid page switching)
        const pages = await report.getPages();


        // Retrieve all the visible pages in the report in order to exclude the non-visible 
        // ones from the export
        const visiblePages = pages.filter(p =>
        (typeof (p as any).isVisible === 'boolean')
            ? (p as any).isVisible
            : (p as any).visibility !== PowerBi.models.SectionVisibility.HiddenInViewMode
        );


        // 5) Build export DTO with only the visible pages
            const exportFileDto: ExportFileDto = {
                fileFormat: exportFileType,
                powerBiReportExportConfiguration: {
                    defaultBookmark: { state: defaultBookmark.state },
                    pages: visiblePages.map(p => ({ pageName: p.name }))
                }
            };


        // Post Export request
        axios.post(`./api/reports/${recordId}/export`,
            exportFileDto,
            {timeout: 50000}
            )
        .then((response) => {
            if (this.state.isExportInProgress != true) {
                console.log("Setting export to in progress");
                this.fileExportDownloadModalChildRef.current?.setExportInProgress();
                this.pollExportProgress(recordId, response.data.id);
            }
        })
        .catch((e: AxiosError) => {
            let errorMessage = e.response?.data ? e.response?.data : e.message;
            this.fileExportDownloadModalChildRef.current?.setError(errorMessage);
        });
    }

    private pollExportProgress(recordId: string, exportId: string) {
        axios.get(`./api/reports/${recordId}/export/${exportId}/status`)
        .then((response) => {
            console.log(response);
            let exportProgressPercentage = Number(response.data.percentComplete);
            if (exportProgressPercentage > 5) {
                this.fileExportDownloadModalChildRef.current?.setExportProgressPercentage(exportProgressPercentage);
            }
            if (exportProgressPercentage == 100 && response.data.resourceFileExtension) {
                this.fileExportDownloadModalChildRef.current?.setExportFileReady(
                    exportId,
                    `./api/reports/${recordId}/export/${exportId}`
                );
            }
            else {
                setTimeout(() => {
                    this.pollExportProgress(recordId, exportId);
                },
                5000);
            }
        })
        .catch((e: AxiosError) => {
            let errorMessage = e.response?.data ? e.response?.data : e.message;
            this.fileExportDownloadModalChildRef.current?.setError(errorMessage);
        });
    }

    render() {
        const pbiModels = PowerBi.models;
        let embeddedRecordAccess = this.props.reportState.embeddedReportDetailsData.find(x => x.aliasName === this.props.reportId || x.recordId == this.props.reportId);


        const NoDataComponent: React.FunctionComponent = (): React.ReactElement => {
            if (!this.props.reportState.isLoadedEmbeddedViewDetails && embeddedRecordAccess === undefined){
                return (
                    <div className="d-flex justify-content-center mt-3" data-cy="bootstrap-table-loaded">
                        <p className="text-center">No Power Bi Report found. (or something is broken!)</p>
                    </div>
                );
            }
            else{
                return (
                    <div className="d-flex justify-content-center mt-3">
                        <Spinner animation="border" variant="primary" role="status">
                            <span className="sr-only">Loading...</span>
                        </Spinner>
                    </div>
                );
            }
        };

    

        if(embeddedRecordAccess === undefined){
            return (
                <div>Report Not Found</div>
            );
        }
       
        return (
            <div id='reportContainer' style={{height: `${this.state.reportContainerHeightPx}` }}>
                <PowerBIEmbed
                    embedConfig={{
                        type: embeddedRecordAccess?.type,
                        embedUrl: embeddedRecordAccess?.embedUrl,
                        accessToken: embeddedRecordAccess?.accessToken,
                        id: embeddedRecordAccess?.recordId,
                        tokenType: PowerBi.models.TokenType.Aad,
                        settings: {
                            layoutType: pbiModels.LayoutType.Custom,
                            customLayout: {
                              displayOption: pbiModels.DisplayOption.FitToPage,
                            },
                        },
                    }}
                    cssClassName={"powerbi-embedded-report-style"}
                    getEmbeddedComponent={ (embedObject: Embed) => {
				        console.log(`Embedded object of type "${ embedObject.embedtype }" received`);
                        actionCreators.setReportEmbeddedComponent(embedObject);
                        this.setState({report: embedObject as PowerBi.Report});

                        embedObject.off('pageChanged');
                        embedObject.on('pageChanged', (event: service.ICustomEvent<any>) =>
                            this.OnPageChanged(event, embedObject)
                        );

                        // Fix the UI 
                        this.updateReportContainer();
			        }}
                    eventHandlers={this.state.eventHandlers}
                />

                <FileExportDownloadModal
                    ref={this.fileExportDownloadModalChildRef}
                    powerBiObjectType={PowerBiObjectType.Report}
                    documentId={this.props.reportId}
                    exportFileType={this.state.exportFileType ?? ExportFileType.Pdf}
                    hideModal={() => this.hideExportRequestModal()} 
                    dispatch={this.props.dispatch} 
                    showModal={this.state.showExportFileModal}
                />
           </div>
        );
    }

};

export default ReportView;